// styles
import "./styles.scss"

function PrimaryButton({ className, onClick, disabled, type, buttonName, loader }) {
  return (
    <>
      <button
        className={`primary-button ${className}`}
        onClick={onClick}
        disabled={disabled}
        type={type}
      >
        {loader ? "Loading..." : buttonName}
      </button>
    </>
  )
}
export default PrimaryButton;